import Check from '@mui/icons-material/Check';
import {Checkbox, FormControlLabel} from '@mui/material';
import {Controller} from 'react-hook-form';

// eslint-disable-next-line react/prop-types
export default ({control, name, label}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={false}
    render={({field}) => (
      <FormControlLabel
        sx={{
          '& .MuiFormControlLabel-label': {
            fontSize: 12,
            color: '#9aa7c3',
            ml: 1.5
          }
        }}
        control={
          <Checkbox
            checkedIcon={<Check color="white" />}
            sx={{
              width: 20,
              height: 20,
              padding: 0,
              backgroundColor: field.value ? 'primary.main' : 'white',
              borderRadius: 1,
              border: field.value ? '1px solid #D6D6D6' : '',
              '&:hover': {
                backgroundColor: field.value ? 'primary.main' : ''
              }
            }}
            {...field}
            checked={field.value}
            size="small"
          />
        }
        label={label}
      />
    )}
  />
);
